import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SessionTrackerService } from '../../shared/service/data/session-tracker.service';

@Injectable({
  providedIn: 'root'
})
export class CaptchaV3UiService {
  private captchaClientApiBaseUrl = 'https://www.google.com/recaptcha/api.js';
  private siteKey = '';
  private scriptId?: number;
  private action?: string;

  public CaptchaTokenSubject = new Subject<string>();

  constructor(private sessionTrackerService: SessionTrackerService) {
    window['reCaptcha3Loaded'] = () => {
      this.getToken(this.action).then((token) => {
        // Pushing token to subscriber
        this.CaptchaTokenSubject.next(token);
      });
    };
  }

  public init(siteKey: any, action: any) {
    this.scriptId = +new Date();
    return new Promise((resolve, reject) => {
      this.siteKey = siteKey;
      this.action = action;
      const script = document.createElement('script');
      script.innerHTML = '';
      script.src = this.captchaClientApiBaseUrl + `?render=${this.siteKey}&onload=reCaptcha3Loaded`;
      script.id = `recapthcha-${this.scriptId}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        resolve('success - postload');
      };
      script.onerror = () => {
        reject('error');
      };
      document.head.appendChild(script);
    });
  }

  public getToken(action?: any): Promise<any> {
    return window['grecaptcha'].execute(this.siteKey, action);
  }

  public validateCaptchaToken(token: string) {
    return this.sessionTrackerService.validateCaptchaToken(token);
  }

  public hideCaptcha() {
    setTimeout(function () {
      // hide captcha icon
      const grecaptchaBadge: any = document.getElementsByClassName('grecaptcha-badge');
      if (grecaptchaBadge != null && grecaptchaBadge.length > 0) {
        grecaptchaBadge[0].parentElement.hidden = true;
      }
    }, 500);
  }
}
